export const iconFontAwesomeDisasterCrisisTemperatureArrowUp = (
	<i className="fa-solid fa-temperature-arrow-up"></i>
);
